import { useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import {
  getProductsQuery,
  useGetProductsPrefetch,
} from "../../hooks/useProducts";
import { numberFormatter } from "../../helper/helpers";
import { addToCart } from "../../Features/Cart/cartActions";
import QuantityControl from "./QuantityControl";
import { slugify } from "../../utils/slugify";

const HomeProductCategory = ({
  categoryName = "",
  param = "",
  category = "",
  extraParams = {},
}) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { cart = [], isLoading } = useSelector((state) => state.itemCart);

  const queryParams = useMemo(
    () => ({
      [param]: category,
      onlyPrescription: false,
      pageSize: 10,
      ...extraParams,
    }),
    [param, category, extraParams],
  );

  let hasExtraParams = Object.keys(extraParams)?.length > 0;
  let extraParam = Object.keys(extraParams)[0] ?? "";

  const handleAddtoCart = (item) => {
    dispatch(addToCart({ ...item, quantity: 1 }));
  };

  useEffect(() => {
    queryClient.prefetchQuery(getProductsQuery(queryParams));
  }, [queryClient, queryParams]);

  const { data = {}, isPending } = useGetProductsPrefetch(queryParams);

  let { data: products = [] } = data?.products ?? {};

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }

  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }

  const isSingleItem = products.length <= 1;
  const slidesToShow = 6;
  const shouldEnableSlider = products.length > slidesToShow;

  const settings = {
    dots: false,
    arrows: products.length > 1,
    infinite: shouldEnableSlider,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    //
    draggable: products.length > 1,
    swipe: products.length > 1,
    //
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: isSingleItem ? 3 : 6,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: isSingleItem ? 3 : 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: isSingleItem ? 3 : 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: isSingleItem ? 3 : 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: isSingleItem ? 3 : 1,
        },
      },
    ],
  };

  return (
    <section className="organic-food py-30">
      <div className="container">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h6 className="mb-0">{categoryName}</h6>
            <div className="flex-align mr-point gap-16">
              <Link
                to={`/products/category?${param}=${category}&${extraParam}=${hasExtraParams}`}
                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                All {categoryName}
              </Link>
            </div>
          </div>
        </div>
        <div className="organic-food__slider arrow-style-two">
          <Slider {...settings}>
            {products.map((product, index) => {
              const cartItem = cart.find(
                (item) =>
                  String(item?.id) === String(product?.id) ||
                  String(item?.productId) === String(product?.id),
              );
              return (
                <div key={product.id}>
                  <div className="product-card px-8 py-16 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 h-100">
                    <Link
                      to={`/products/product-details/${product?.id}?name=${slugify(product?.name)}`}
                      state={product}
                      className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                    >
                      {product?.stockQuantity === 0 && (
                        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                          Out of Stock
                        </span>
                      )}
                      {/* <span className="product-card__badge bg-main-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                      Best Seller
                    </span> */}
                      {/* <img
                      src="assets/images/thumbs/product-two-img5.png"
                      alt=""
                      className="w-auto max-w-unset"
                    /> */}

                      <img
                        src={
                          product?.hasMainImage
                            ? product?.imageUrl
                            : "/assets/images/thumbs/product-two-img2.png"
                        }
                        alt={product.name}
                        // style={{
                        //   height: "180px",-
                        //   width: "100%",
                        //   objectFit: "contain",
                        // }}
                      />
                    </Link>
                    <div className="product-card__content mt-12 w-100">
                      {/* <div className="flex-align gap-6">
                    <span className="text-xs fw-bold text-gray-500">4.8</span>
                    <span className="text-15 fw-bold text-warning-600 d-flex">
                      <i className="ph-fill ph-star" />
                    </span>
                    <span className="text-xs fw-bold text-gray-500">(17k)</span>
                  </div> */}
                      <h6 className="title text-md fw-semibold mt-12 mb-8">
                        <Link
                          to={`/products/product-details/${product?.id}?name=${slugify(product?.name)}`}
                          state={product}
                          className="link text-line-2"
                        >
                          {product?.name}
                        </Link>
                      </h6>
                      {/* <div className="flex-align gap-4">
                    <span className="text-main-600 text-md d-flex">
                      <i className="ph-fill ph-storefront" />
                    </span>
                    <span className="text-gray-500 text-xs">
                      By Lucky Supermarket
                    </span>
                  </div> */}
                      <div className="flex-between gap-8 mt-24 flex-wrap">
                        <div className="product-card__price">
                          {/* <span className="text-gray-400 text-md fw-semibold text-decoration-line-through d-block">
                        $28.99
                      </span> */}
                          <span className="text-heading text-sm fw-semibold ">
                            {numberFormatter.format(Number(product?.price))}
                            <span className="text-gray-500 fw-normal">
                              /Qty
                            </span>
                          </span>
                        </div>
                        {!cartItem && (
                          <button
                            className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8"
                            disabled={product?.stockQuantity === 0 || isLoading}
                            onClick={() => handleAddtoCart(product)}
                          >
                            {isLoading ? (
                              <div
                                className="spinner-border spinner-border-sm me-5"
                                role="status"
                              ></div>
                            ) : (
                              <>
                                Add <i className="ph ph-shopping-cart" />
                              </>
                            )}
                          </button>
                        )}

                        {cartItem && (
                          <QuantityControl
                            currentItem={{ ...product, ...cartItem }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default HomeProductCategory;
